import { mapToMerchandiseVendors, mapToRealVendors } from "helpers/vendorHelper";
import { getAppConfig } from "services/configService";

const apiUrl = () => {
  return getAppConfig().MerchandiseApiUrl;
};

const queryMerchandise = query => {
  const result = fetch(apiUrl(), {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    responseType: "application/json",
    body: query
  }).then(response => {
    return response.json();
  });
  return result;
};

const buildGraphQLQuery = (query, variables) => {
  const graphQL = JSON.stringify({
    query: query,
    variables: variables
  });
  return graphQL;
};

export const getAllChannelsAndVendors = async () => {
  const query = "query {	Channels { ID	Vendor {	ID	Locale	} }	}";
  const graphQL = buildGraphQLQuery(query, {});
  const response = await queryMerchandise(graphQL);
  response.data.Channels = response.data.Channels.filter(c => !!c.Vendor && !!c.Vendor.ID).map(c => {
    c.ID = mapToRealVendors(c.ID);
    return c;
  });
  return response;
};

export const getChannel = async (channel, locale) => {
  const query = `query ($channelCode: String!, $locale: String!) {
      Channel(Code: $channelCode, Locale: $locale) {
        ID
        ShopUrl
        Articles{
          ID
          ArticleType
          Title
          PageHeight
          PageWidth
          Visible
          Links {
            Href Rel
          }
          ArticleExtras {
            Extras {
              Border {
                ID
                Options {
                  ID
                  Title
                }
              }
              CoverText {
                ID
                Options {
                  ID
                  Title
                }
              }
              CoverType {
                ID
                Options {
                  ... on PhotoCoverOption {
                    ID
                    Title
                  }
                  ... on CoverTypeOption {
                    ID
                    Title
                  }
                }
              }
              ExtraPages {
                ID
                Options {
                  ID
                  Title
                }
              }
              FloatingFrame {
                ID
                Options {
                  ID
                  Title
                }
              }
              Glossy {
                ID
                Options {
                  ID
                  Title
                }
              }
              ImageEnhancement {
                ID
                Options {
                  ID
                  Title
                }
              }
              LayFlat {
                ID
                Options {
                  ID
                  Title
                }
              }
              Linnen {
                ID
                Options {
                  ID
                  Title
                }
              }
              Paper {
                ID
                Options {
                  ID
                  Title
                }
              }
              PlanksOrientation {
                ID
                Options {
                  ID
                  Title
                }
              }
              PremiumLayFlat {
                ID
                Options {
                  ID
                  Title
                }
              }
              PrintSize {
                ID
                Options {
                  ID
                  Title
                }
              }
              Toggles {
                ID
                Options {
                  ID
                  Title
                }
              }
              VoucherDiscount {
                ID
                Options {
                  ID
                  Title
                }
              }
              WoodFinishing {
                ID
                Options {
                  ID
                  Title
                }
              }
              Wrappers {
                ID
                Options {
                  ID
                  Title
                }
              }
            }
          }
        }
        Currency {
          ID
        }
      }
    }`;

  const channelCode = mapToMerchandiseVendors(channel);

  const variables = { channelCode, locale: locale };
  const graphQL = buildGraphQLQuery(query, variables);
  const response = await queryMerchandise(graphQL);
  response.data.Channel.ID = channel; //reset "onskefoto.se"
  return response;
};
